import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MourturyComponent} from './mourtury.component';

const routes: Routes = [
  {path: 'mourtury', component: MourturyComponent}
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mourtury/mourtury.routing.ts